import { createSlice } from '@reduxjs/toolkit'
import { logoutUser } from '../middlewares/logoutMiddleware'

const initialState = {
    progress: {},
    consistencyCheckCompleted: false,
}

const assignmentsPersistSlice = createSlice({
    name: 'assignmentsPersist',
    initialState,
    reducers: {
        setProgressState: (state, action) => {
            const { token, step, checkbox, value } = action.payload
            if (!state.progress[token]) state.progress[token] = {}
            if (!state.progress[token][step]) state.progress[token][step] = {}

            state.progress[token][step][checkbox] = value
        },
        setManyProgressStates: (state, action) => {
            const { token, progressStates } = action.payload
            if (!state.progress[token]) state.progress[token] = {}

            progressStates.forEach(({ step, checkbox, value }) => {
                if (!state.progress[token][step]) state.progress[token][step] = {}
                state.progress[token][step][checkbox] = value
            })
        },
        setConsistencyCheckCompleted: (state, action) => {
            state.consistencyCheckCompleted = action.payload
        },
        reset: () => initialState,
    },
    extraReducers: builder => builder.addCase(logoutUser, () => initialState),
})

export const assignmentsPersistActions = assignmentsPersistSlice.actions

export default assignmentsPersistSlice.reducer
